
import './style.scss'
import WatchVideo from '../../components/watchVideo/WatchVideo';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { useEffect } from 'react';
import { interactionConnector } from '../../server/connector/interactionConnector';
import { setChatDataLoaded } from '../../redux/reducers/userSlice';
import { setSubPage } from '../../redux/reducers/dashboardSlice';
import { DashboardSubPages } from '../../types/types';
import { PAGE_URLS } from '../../constants/hrefLinks';
import { adminStateData } from '../../data/adminStateData';
import AdminSideMenu from '../../sections/adminSideMenu/AdminSideMenu';
import { useCookies } from 'react-cookie';
import AdminChatContentArea from '../../sections/adminChatContentArea/AdminChatContentArea';
import AdminHeader from '../../sections/adminHeader/AdminHeader';

function AdminChat() {
	const showWatchVideos: boolean = useAppSelector(state => state.chat.showWatchVideos)

	const loginChecked: boolean = useAppSelector(state => state.user.loginChecked)
	const [cookies] = useCookies()
	const dispatch = useAppDispatch()

	useEffect(() => {
		dispatch(setSubPage(DashboardSubPages.CHATS))
		// check if log in has been checked and confirmed in App.tsx
		if (cookies?.adminLogin) {
			adminStateData.loggedIn = cookies?.adminLogin
			loadChatData()
		} else {
			window.location.replace(PAGE_URLS.ADMIN_LOGIN)
		}
	}, [loginChecked])

	const loadChatData = () => {
		const querySting: string = window.location.search;
		const urlParams: URLSearchParams = new URLSearchParams(querySting)
		const profileId: string | null = urlParams.get('id')

		if (!profileId) {

		} else {
			if (interactionConnector.requestInProgress) {
				console.log('[AdminChat] - loadChatData() called while requestInProgress')
			} else {
				if (profileId) {
					interactionConnector.performGetInteractionRequest(profileId).then((successRequest) => {
						dispatch(setChatDataLoaded(true))
						// setProfileRequestCompleted(true)
						if (!successRequest) {
							console.log('WARNING - [AdminChat] - requestProfile() failed')
						}
					})
				}
			}
		}
	}

	return (
		<div className='dashboard-wrap'>
			{loginChecked &&
				<>
					<AdminSideMenu />
					<div
						className='dashboard-content-wrap'
					>
						<AdminHeader title='Admin - Chat' />
						<AdminChatContentArea />
					</div>
					{/* {showWatchVideos && <WatchVideo videoUrls={[]} />} */}
					{showWatchVideos && <WatchVideo />}
				</>
			}
		</div>
	)
}

export default AdminChat
